import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import login from './modules/login'
import tableData from './modules/tableData'
import bluetooth from './modules/bluetooth'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    login,
    tableData,
    bluetooth
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js